import { updateBumblebeeSessionTitle } from "../../../../../../../../../shared/api/bumblebee/bumblebee";

export const updateBumblebeeChatTitleService = async (
	sessionId: string,
	title: string,
) => {
	const result = await updateBumblebeeSessionTitle({
		session_id: sessionId,
		body: { title },
	});
	return result.data;
};
